"use client";

import { useEffect, useState } from "react";
import cnBind from "classnames/bind";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

import styles from "./CookieConsentBanner.module.scss";

const cx = cnBind.bind(styles);

const STORAGE_KEY = "tezam-cookie-consent";
const SHOW_MS = 15_000;
const FADE_MS = 700;

export const CookieConsentBanner = () => {
    const { t } = useTranslation("common");
    const [mounted, setMounted] = useState(false);
    const [leaving, setLeaving] = useState(false);

    const dismiss = () => {
        if (typeof window !== "undefined") {
            window.localStorage.setItem(STORAGE_KEY, "accepted");
        }
        setLeaving(true);
        window.setTimeout(() => setMounted(false), FADE_MS);
    };

    useEffect(() => {
        if (typeof window === "undefined") return;
        if (window.localStorage.getItem(STORAGE_KEY) === "accepted") return;

        setMounted(true);

        const fadeTimer = window.setTimeout(() => {
            setLeaving(true);
        }, SHOW_MS);

        const hideTimer = window.setTimeout(() => {
            window.localStorage.setItem(STORAGE_KEY, "accepted");
            setMounted(false);
        }, SHOW_MS + FADE_MS);

        return () => {
            window.clearTimeout(fadeTimer);
            window.clearTimeout(hideTimer);
        };
    }, []);

    if (!mounted) return null;

    return (
        <div
            className={cx("snackbar", { leaving })}
            role="status"
            aria-live="polite"
            aria-label={t("cookie.aria")}
        >
            <p className={cx("text")}>{t("cookie.text")}</p>
            <button type="button" className={cx("close")} onClick={dismiss} aria-label={t("cookie.close")}>
                <X size={16} strokeWidth={2.2} />
            </button>
        </div>
    );
};
